import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router'

import { AdditionalProfileManagementConfig } from '../../../../../state/configuration'
import { AppPath } from '../../../../AppPath'
import { PolicyAdjustmentResultRouter } from '../results'
import {
  AdditionalProfileAdjustmentPage,
  AdditionalProfileCreateAdjustmentPage,
} from './AdditionalProfileAdjustmentPage'
import { AdditionalProfileAdjustmentPath } from './AdditionalProfileAdjustmentPath'

export interface DisclosureFormProps {
  config: AdditionalProfileManagementConfig
}

export const AdditionalProfileAdjustmentRouter: FunctionComponent<
  DisclosureFormProps
> = ({ config }) => {
  const navigate = useNavigate()

  return (
    <Routes>
      <Route
        path={AdditionalProfileAdjustmentPath.Review + AppPath.WILDCARD}
        element={
          <PolicyAdjustmentResultRouter
            config={config}
            onComplete={() => navigate('../..')}
            onRepeat={() => navigate('..')}
          />
        }
      />

      <Route
        path={AdditionalProfileAdjustmentPath.Profile}
        element={<AdditionalProfileAdjustmentPage config={config} />}
      />

      <Route
        path={AdditionalProfileAdjustmentPath.NewProfile}
        element={<AdditionalProfileCreateAdjustmentPage config={config} />}
      />

      <Route path='*' element={<Navigate to='../..' />} />
    </Routes>
  )
}
